import { NgModule,
    Component }                 from '@angular/core';
import { NavController,
    IonicApp,
    IonicModule}                from 'ionic-angular';
import { ViewChild }            from    '@angular/core';
import { Platform }             from 'ionic-angular';

import {FaceBookService}        from '../../providers/facebook-provider';
import {FirebaseService}        from '../../providers/firebase-provider';
import {UserService}            from '../../providers/userService-provider';

declare var window: any;

@Component({
    selector: 'login-profile',  
    templateUrl: 'profile.page.html'
})
export class profileComponent {
    
    constructor(
        private platform: Platform,
        private faceBookService: FaceBookService,
        private firebaseService: FirebaseService
    ) {        
    }        
}

@Component({
    selector: 'login-profileheader',
    template: `
        <ion-item end>        
        <h2>{{userService.userStatus.displayName}}</h2>    
        <ion-avatar item-right>        
            <img [src]="userService.userStatus.photoURL">
        </ion-avatar>
        
    </ion-item>
    `
})
export class profileHeaderComponent {

    constructor(
        private platform: Platform,
        private faceBookService: FaceBookService,
        private userService: UserService
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/feature/loginModule/pages/profile/profile.page.ts